import mutations from './driverLicense.mutations'
import actions from './driverLicense.actions'
import getters from './driverLicense.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
